import React, { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './AdminDashboardPage.module.css';
import { BASE_TRANSACTIONS_URL } from '~/helper/apiService';

const cx = classNames.bind(styles);

function AddPoint() {
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleAddPoint = async () => {
    if (!phone) {
      setMessage('Vui lòng nhập số điện thoại');
      setIsError(true);
      return;
    }

    try {
      const response = await fetch(`${BASE_TRANSACTIONS_URL}add-point`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setIsError(false);
        setPhone('');
      } else {
        setMessage(data.error || 'Có lỗi xảy ra');
        setIsError(true);
      }
    } catch (error) {
      setMessage('Lỗi kết nối: ' + error.message);
      setIsError(true);
    }
  };

  return (
    <div className={cx('add-point-section')}>
      <div className={cx('search-form')}>
        <input
          type="text"
          placeholder="Nhập số điện thoại"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={cx('input')}
        />
        <button
          onClick={handleAddPoint}
          className={cx('button')}
        >
          Thêm Điểm
        </button>
      </div>
      {message && (
        <p className={cx('message', { error: isError, success: !isError })}>
          {message}
        </p>
      )}
    </div>
  );
}

export default AddPoint;